export default "__VITE_ASSET__b6c97523__"